import type { SpeechPlaybackEvent } from "./speech";

export interface SpeechLease {
  readonly kind: "guidance" | "community" | "camera";
  readonly cameraId?: string;
}

/** Synchronous ownership also covers the time before React commits speech status. */
export class SpeechArbiter {
  private active: SpeechLease | null = null;
  constructor(private readonly changed: () => void = () => {}) {}
  get current() {
    return this.active;
  }
  owns(lease: SpeechLease) {
    return this.active === lease;
  }
  begin(kind: SpeechLease["kind"], cameraId?: string): SpeechLease | null {
    if (kind === "camera" && this.active) return null;
    const lease = { kind, cameraId };
    this.active = lease;
    this.changed();
    return lease;
  }
  finish(lease: SpeechLease): boolean {
    if (!this.owns(lease)) return false;
    this.active = null;
    this.changed();
    return true;
  }
  clear() {
    if (!this.active) return;
    this.active = null;
    this.changed();
  }
}

export function isSpeechPlaybackPending(event: SpeechPlaybackEvent): boolean {
  return event.state === "preparing" || event.state === "playing";
}
